<template>
  <div>
    <Navbar />
    <div class="main-content">
      <transition name="fade" mode="out-in">
        <router-view class="view-area"></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar";
export default {
  components: {
    Navbar,
  },
  data() {
    return {};
  },
  beforeRouteLeave(to, from, next) {
    if (from.name == "Home") {
    }
    next();
  },
};
</script>